export default function isUndefined(o) {
  return typeof o === 'undefined';
}